export default {"src":"/_next/static/media/arrow-down.97412dec.svg","height":24,"width":13};